var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9844 11.9844H7.32581C6.76488 11.9844 6.31018 12.4391 6.31018 13C6.31018 13.5609 6.76488 14.0156 7.32581 14.0156H24.9844C25.5453 14.0156 26 13.5609 26 13C26 12.4391 25.5453 11.9844 24.9844 11.9844Z",
    fill: "#283856"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9844 4.36719H7.32581C6.76488 4.36719 6.31018 4.82188 6.31018 5.38281C6.31018 5.94374 6.76488 6.39844 7.32581 6.39844H24.9844C25.5453 6.39844 26 5.94374 26 5.38281C26 4.82188 25.5453 4.36719 24.9844 4.36719Z",
    fill: "#283856"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9844 19.6016H7.32581C6.76488 19.6016 6.31018 20.0563 6.31018 20.6172C6.31018 21.1781 6.76488 21.6328 7.32581 21.6328H24.9844C25.5453 21.6328 26 21.1781 26 20.6172C26 20.0563 25.5453 19.6016 24.9844 19.6016Z",
    fill: "#283856"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.37109 6.75391C2.12833 6.75391 2.74219 6.14005 2.74219 5.38281C2.74219 4.62558 2.12833 4.01172 1.37109 4.01172C0.61386 4.01172 0 4.62558 0 5.38281C0 6.14005 0.61386 6.75391 1.37109 6.75391Z",
    fill: "#283856"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.37109 14.3711C2.12833 14.3711 2.74219 13.7572 2.74219 13C2.74219 12.2428 2.12833 11.6289 1.37109 11.6289C0.61386 11.6289 0 12.2428 0 13C0 13.7572 0.61386 14.3711 1.37109 14.3711Z",
    fill: "#283856"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.37109 21.9883C2.12833 21.9883 2.74219 21.3744 2.74219 20.6172C2.74219 19.86 2.12833 19.2461 1.37109 19.2461C0.61386 19.2461 0 19.86 0 20.6172C0 21.3744 0.61386 21.9883 1.37109 21.9883Z",
    fill: "#283856"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/List.c667bf224a51aa43b887bc582c3507ed.svg";
export { ForwardRef as ReactComponent };